(function() {
    'use strict';

    angular
        .module('app.clientes')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/clientes',
                config: {
                    templateUrl: 'app/clientes/list.html',
                    controller: 'clientes.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-cliente/:id?',
                config: {
                    templateUrl: 'app/clientes/edit.html',
                    controller: 'clientes.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
